module.exports = __webpack_public_path__ + "img/capac_pais.e111adcc.jpg";